import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_APP_DEFAULT_LINK,
    headers: {
        'Content-Type': 'application/json'
    }
})

export default api;